import type { MRT_ExpandedState } from "mantine-react-table-open";
import type { ExpressOnboardingGenerator } from "../../ExpressOnboarding.types";
import { getSiteMissingData } from "./getSiteMissingData";

/**
 * Sites with missing data are expanded by default.
 * Grouped row ids have the form `${groupingColumnId}:${groupValue}`.
 */
function getDefaultExpandedSites(
  generators: Array<ExpressOnboardingGenerator>
): MRT_ExpandedState {
  const siteIds = new Set(generators.map((generator) => generator.site_id));

  return [...siteIds].reduce<Record<string, boolean>>((expanded, siteId) => {
    const { isMissingGeneralData, isMissingEegAnlageData } = getSiteMissingData(
      generators.filter((generator) => generator.site_id === siteId)
    );
    expanded[`site_id:${siteId}`] =
      isMissingGeneralData || isMissingEegAnlageData;
    return expanded;
  }, {});
}

export { getDefaultExpandedSites };
